import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { myProfileService } from '@app/services';
import {PasslySelect, PasslyMaskedInput, PasslyTextField} from '..';
import { digitRegex, genericErrorString } from '@app/helpers';

export interface IReceivedData {
    handleSubmitValues: Function;
}

export function PhoneNumberInputComponent(props: IReceivedData) {
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState('');
    const [countryCodeSelected, setCountryCodeSelected] = useState('United States|+1');
    const [countryCodes, setCountryCodes] = useState([] as any);
    const [mobilePhoneChosen, setMobilePhoneChosen] = useState('');

    useEffect(() => {
        myProfileService.getDefaults(handleError, handleDefaults);
    }, []);

    const handleDefaults = (results: any) => {
        const countries = results.data.countries;

        if (countries) {
            const allCountryCodes: any[] = [];

            countries.forEach(function (country: any) {
                allCountryCodes.push({ value: country.name + '|' + country.callingCode, label: country.name + ' ' + country.callingCode, preferred: country.isPreferred, name: country.name });
            });

            allCountryCodes.sort(function (a: any, b: any) {
                if (a.preferred) {
                    return -100;
                }

                if (b.preferred) {
                    return 100;
                }

                return a.name > b.name ? 1 : -1;
            }.bind(allCountryCodes));

            setCountryCodes(allCountryCodes);
        }
    };

    const handleError = (error: any) => {
        setErrorMessage(genericErrorString(error));
    };

    const onFormChange = (e: any) => {
        let { name, value } = e.target;

        value = value.trim();

        switch (name) {
            case 'countryCode':
                setCountryCodeSelected(value);
                props.handleSubmitValues(value, mobilePhoneChosen);
                break;
            case 'mobilePhone':
                setMobilePhoneChosen(value);
                props.handleSubmitValues(countryCodeSelected, value);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <div>
                <div className='modal__body--inner_row'>{translation('MOBILE_PHONE')}</div>
                <div className='modal__input--row'>
                    <div className='modal__input--column'>
                        <PasslySelect
                            name='countryCode'
                            value={countryCodeSelected}
                            onChange={onFormChange}
                            id='initialState-input'
                            options={countryCodes}
                            appendTo={document.body}
                        />
                    </div>
                    <div className='modal__input--column'>
                        <PasslyTextField
                            fullWidth
                            name='mobilePhone'
                            label=''
                            value={mobilePhoneChosen}
                            onChange={onFormChange}
                            id='mobilePhone-input'
                            InputProps={{
                                inputComponent: PasslyMaskedInput,
                                inputProps: {
                                    maskSize: 15,
                                    maskRegex: digitRegex
                                },
                            }}
                            required
                            autoFocus />
                    </div>
                </div>
            </div>
            {
                errorMessage &&
                <div className='modal__error'>{errorMessage}</div>
            }
        </>
    );
}
